import * as React from 'react';
import './FormTemplateFileTypesPage.scss';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as FormTemplateFileTypeActions from '../../../actions/formTemplateFileTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { QALookupsLayout } from '../../index';

interface IFormTemplateFileTypesPageProps {

    location: Location;
    history: History;

    // From state
    formFilter: IFormFilter;
    formTemplateFileTypes: Dtos.FormTemplateFileType[];
    loadingFormTemplateFileTypes: boolean;
    loadFormTemplateFileTypesSuccess: boolean;
    loadFormTemplateFileTypesFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];
}

interface IFormTemplateFileTypesPageActions {
    clearFormTemplateFileTypes: FormTemplateFileTypeActions.IFormTemplateFileTypeClearActionCreator;
    loadFormTemplateFileTypes: FormTemplateFileTypeActions.IFormTemplateFileTypeLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: FormTemplateFileTypeActions.IFormTemplateFileTypeFilterActionCreator;
}

type FormTemplateFileTypesPageProps = IFormTemplateFileTypesPageProps & IFormTemplateFileTypesPageActions;

class FormTemplateFileTypesPage extends React.PureComponent<FormTemplateFileTypesPageProps, any> {

    constructor(props: FormTemplateFileTypesPageProps) {
        super(props);

        this.clearFormTemplateFileTypes = this.clearFormTemplateFileTypes.bind(this);
    }

    componentDidMount() {
        const {
            loadFormTemplateFileTypes
        } = this.props;

        loadFormTemplateFileTypes();
    }

    componentWillReceiveProps(nextProps: FormTemplateFileTypesPageProps) {
    }

    componentDidUpdate(prevProps: FormTemplateFileTypesPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: FormTemplateFileTypesPageProps) {
    }

    componentWillUnmount() {
        this.clearFormTemplateFileTypes();
    }

    clearFormTemplateFileTypes() {
        this.props.clearFormTemplateFileTypes();
    }

    showFormTemplateFileTypes(): boolean {
        const {
            loadingFormTemplateFileTypes,
            loadFormTemplateFileTypesSuccess
        } = this.props

        if (!loadingFormTemplateFileTypes && loadFormTemplateFileTypesSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingFormTemplateFileTypes
        } = this.props;

        return <QALookupsLayout loading={loadingFormTemplateFileTypes} permission={Dtos.Permission.FormTemplateFileTypesView}>
            {this.renderContent()}
        </QALookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>File Types</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e) } />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FormTemplateFileTypesCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/qa/formTemplateFileTypes/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showFormTemplateFileTypes() ?
                    "Loading File Types" :
                    null
            }
            {
                this.showFormTemplateFileTypes() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            formTemplateFileTypes
        } = this.props

        if (!formTemplateFileTypes || formTemplateFileTypes.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no file types to view.</span>
            </div>
        }

        const showPagination = formTemplateFileTypes.length > DEFAULT_PAGE_SIZE;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={formTemplateFileTypes}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : formTemplateFileTypes.length}
                pageSize={showPagination ? undefined : formTemplateFileTypes.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no formTemplateFileType to display"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/qa/formTemplateFileTypes/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        },
                        style: {
                            color: (rowInfo && rowInfo.original && rowInfo.original.active) ? '#212529' : '#9e9e9e'
                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: FormTemplateFileTypesPageProps): IFormTemplateFileTypesPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        formFilter: state.formTemplateFileTypes.formFilter,
        formTemplateFileTypes: state.formTemplateFileTypes.formFilteredData, 

        loadingFormTemplateFileTypes: state.formTemplateFileTypes.loadState && state.formTemplateFileTypes.loadState.status == RequestState.Pending,
        loadFormTemplateFileTypesSuccess: state.formTemplateFileTypes.loadState && state.formTemplateFileTypes.loadState.status == RequestState.Success,
        loadFormTemplateFileTypesFailure: state.formTemplateFileTypes.loadState && state.formTemplateFileTypes.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles
    };
};

const mapDispatchToProps = (dispatch): IFormTemplateFileTypesPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadFormTemplateFileTypes: bindActionCreators(FormTemplateFileTypeActions.LoadFormTemplateFileType, dispatch),
        clearFormTemplateFileTypes: bindActionCreators(FormTemplateFileTypeActions.Clear, dispatch),

        filter: bindActionCreators(FormTemplateFileTypeActions.Filter, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(FormTemplateFileTypesPage);
